import API from './api';
import { getClienteAtual, getClienteFromCookie } from '../services/authentication/auth';

const host = process.env.REACT_APP_API_HUB;

/**
 * Resolve o header x-one7-codcliente esperado pelo AutenticacaoChatIa
 * (App\Http\Middleware\AutenticacaoChatIa) do api-hub. O backend NUNCA confia
 * neste valor como permissao — ele so restringe a busca a esse cliente SE ele
 * ja estiver no escopo do usuario autenticado (rlc_usuarios_clientes),
 * respondendo 403 caso contrario. 'todos' faz o backend considerar todos os
 * clientes visiveis ao usuario.
 */
const resolverCodClienteHeader = () => {
  const clienteSessao = getClienteAtual();
  const clienteCookie = getClienteFromCookie();

  const candidato = clienteSessao?.CODCLIENTE ?? clienteSessao ?? clienteCookie;

  if (candidato === null || candidato === undefined || candidato === '') {
    return 'todos';
  }

  return String(candidato);
};

const headersChatIa = () => ({
  'x-one7-codcliente': resolverCodClienteHeader()
});

/**
 * Variante com streaming: a resposta HTTP e identica a de enviarMensagemChatIa,
 * mas o backend publica os pedacos do texto no canal privado do Reverb
 * enquanto o modelo escreve. Nao usa SSE porque o Kong serve as rotas com
 * response_buffering ligado, o que anularia o streaming.
 */
export const enviarMensagemChatIaStream = ({ mensagem, uuidConversa, codClienteSelecionado }) =>
  API.post(
    `${host}/chat-ia/v1/mensagens/stream`,
    {
      mensagem,
      uuid_conversa: uuidConversa ?? null,
      cod_cliente_selecionado: codClienteSelecionado ?? null
    },
    { headers: headersChatIa() }
  );

export const enviarMensagemChatIa = ({ mensagem, uuidConversa, codClienteSelecionado }) =>
  API.post(
    `${host}/chat-ia/v1/mensagens`,
    {
      mensagem,
      uuid_conversa: uuidConversa ?? null,
      cod_cliente_selecionado: codClienteSelecionado ?? null
    },
    { headers: headersChatIa() }
  );

export const listarConversasChatIa = () =>
  API.get(`${host}/chat-ia/v1/conversas`, { headers: headersChatIa() });

export const detalharConversaChatIa = uuid =>
  API.get(`${host}/chat-ia/v1/conversas/${uuid}`, { headers: headersChatIa() });

export const arquivarConversaChatIa = uuid =>
  API.delete(`${host}/chat-ia/v1/conversas/${uuid}`, { headers: headersChatIa() });

export const listarSugestoesChatIa = (termo, { signal } = {}) =>
  API.get(`${host}/chat-ia/v1/sugestoes`, {
    params: termo ? { termo } : {},
    headers: headersChatIa(),
    signal
  });
